import { cloneDeep } from "lodash-es";
import { useEffect, useRef } from "react";
import { useSwitchNetwork } from "wagmi";
import { GlobalStore } from "../store/global/GlobalStore";
import {
  processNetworkFromUrl,
  processTokensFromUrl,
  updateUrlParams,
  URL_KEYS,
} from "../utils/urlUtils";
import { useTokenListByChain } from "./useTokenListByChain";
import { UserRejectedRequestError } from "viem";

export function useUrlNetworkParams() {
  const params = new URL(window.location as unknown as string).searchParams;
  const network = params.get(URL_KEYS.NETWORK);
  const sellTokens = params.get(URL_KEYS.SELL);
  const buyTokens = params.get(URL_KEYS.BUY);
  const networkNameFromStore = GlobalStore.useState(s => s.network.name);

  const { switchNetwork } = useSwitchNetwork({
    onError: (error: Error) => {
      if (error instanceof UserRejectedRequestError) {
        // User rejected the network switch request, so we should clean the URL
        updateUrlParams(
          URL_KEYS.NETWORK,
          networkNameFromStore.toLowerCase(),
          window.location.pathname
        );
        updateUrlParams(URL_KEYS.SELL, "", window.location.pathname);
        updateUrlParams(URL_KEYS.BUY, "", window.location.pathname);
      }
    },
  });
  const tokenList = useTokenListByChain();
  const currentNetwork = GlobalStore.useState(s => s.network);
  const hasProcessedUrl = useRef(false);
  const hasRequestedNetworkSwitch = useRef(false);

  useEffect(() => {
    if (hasRequestedNetworkSwitch.current) return;
    const networkMatch = processNetworkFromUrl(network);
    if (networkMatch && switchNetwork && networkMatch.name !== currentNetwork.name) {
      hasRequestedNetworkSwitch.current = true;
      try {
        switchNetwork(networkMatch.id);
      } catch (error) {
        console.log("Error switching networks");
        console.log(error);
      }
    } else if (networkMatch && networkMatch.name !== currentNetwork.name) {
      GlobalStore.update(s => {
        s.network = cloneDeep(networkMatch) as typeof s.network;
      });
    }
  }, [currentNetwork, sellTokens, network, switchNetwork, buyTokens, tokenList]);

  useEffect(() => {
    if (hasProcessedUrl.current) return;
    if (tokenList) {
      processTokensFromUrl(sellTokens, buyTokens, tokenList);
      hasProcessedUrl.current = true;
    }
  }, [buyTokens, networkNameFromStore, sellTokens, tokenList]);
}
